module.exports = __webpack_public_path__ + "static/media/pic4.8e9e3a92.jpg";